export default __webpack_public_path__ + "static/media/010_home.2800443b.mp4";